import { useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';
import { useApi } from '@/shared/api';
import type { CreateManualBookingRequest } from '@/shared/api';
import { formatAccommodationPrice } from '@/shared/lib/bookingPrice';

interface UseManualBookingArgs {
  onSuccess: (operationId: string) => boolean;
}

export function useManualBooking({ onSuccess }: UseManualBookingArgs) {
  const api = useApi();
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (body: CreateManualBookingRequest) => api.bookings.createManual(body),
    onSuccess: async (booking, request) => {
      if (!request.operationId || !onSuccess(request.operationId)) return;
      await queryClient.invalidateQueries({ queryKey: ['bookings'] });
      await queryClient.invalidateQueries({ queryKey: ['calendar'] });
      const nights = Math.max(
        0,
        Math.round(
          (new Date(booking.checkOutDate).getTime() - new Date(booking.checkInDate).getTime()) /
            86400000,
        ),
      );
      toast.success(
        `Buchung angelegt – ${nights} ${nights === 1 ? 'Nacht' : 'Nächte'}, ${formatAccommodationPrice(booking)}`,
      );
    },
    // Der Grund steht im Fuß des Panels (ManualBookingFooter), nicht in einem Toast, der verschwindet.
    // Eine Ablehnung heißt oft: der Zeitraum ist inzwischen belegt – also neu prüfen.
    onError: () => void queryClient.invalidateQueries({ queryKey: ['channex', 'availability'] }),
  });
}
